<template>
  <div class="superpowers page">
    <div class="main-banner-szuper" ref="scrollHeightBlock">
      <b-container>
        <b-row>
          <b-col cols="12" lg="10" offset-lg="1">
              <div class="superpowers__text">
                <div class="logo-wrap"><img src="@/assets/images/brand/logo-white-header-2x.png" alt="Soproni" class="w-100"></div>                
                <p>Minél nagyobb a napi hajtás, annál fontosabb, hogy érezzük: nem vagyunk egyedül, mert már 130 éve összetartozunk, mint az este és a haverok, mint a fesztivál és a sátrazás, mint a szülinap és a meglepetés, vagy mint az északi és a déli part. Igen, összetartozunk.<br/><br/>
Soproni. Töltsük együtt.</p>
                <button class="btn--scroll-down"  @click="scrollToNextBlock"></button>
            </div>
          </b-col>
        </b-row>        
      </b-container><!-- /.container -->
    </div>
    <b-container>
      <b-row>
        <b-col cols="12">
            <div class="video-szuper" v-inview="'fade-up'">        
              <Video 
                :staticVideoName="'soproni-citrus.mp4'" 
                :staticVideo="true" 
                :video="null" 
                :needScrollBtn="false" 
                :poster="'soproni-citrus.jpg'"                
              />
          </div>    
          <div class="amikozos-logo" v-inview="'fade-up'">            
            <!-- <img src="@/assets/images/brand/soproni_amikozos.png" alt="Soproni - ami közös benünk" class="w-100" />             -->
            <h4>Összetartozunk, mint a társaság és a Soproni </h4>
          </div>          
        </b-col>
      </b-row>
    </b-container>       
  </div>
</template>

<script>
import Video from '@/components/layout/Video.vue'

export default {
  components:{
    Video
  },
  methods:{
    scrollToNextBlock(){            
        let scrollHeight = this.$refs.scrollHeightBlock.clientHeight

        window.scrollTo({
            left: 0, 
            top: scrollHeight,
            behavior: 'smooth'
        });                 
                    
    }
  },
  mounted(){
    this.setMetaTags({
        title: 'Soproni - Szuperképességek', 
        desc: null, 
        keywords: null, 
        ogType: 'website', 
        ogTitle: 'Soproni - Szuperképességek',                         
        ogImage: null, 
        ogImageWidth: null, 
        ogImageHeight: null, 
        ogDesc:null
    })
  }
}
</script>